import { STEP_IDS } from '../constants';
import { isExperienceType } from '../experienceTypes';

const WIZARD_CONFIG = {
  id: 'integration-wizard-v2',
  version: '1.0.0',

  steps: [
    {
      id: STEP_IDS.EXPERIENCE_SELECTION,
      title: "ui.integrationWizard.config.wizardConfig.welcome",
      description: "ui.integrationWizard.config.wizardConfig.welcomeToYourSearchSetup",
      validate: () => true,
      visible: () => true,
    },
    {
      id: 'choose-experience',
      title: "ui.integrationWizard.config.wizardConfig.chooseExperience",
      description: "ui.integrationWizard.config.wizardConfig.pickHowSearchAppearsOnYourStore",
      validate: (data) => isExperienceType(data.selectedExperience),
      visible: () => true,
    },
    {
      id: 'component-configuration',
      title: "ui.integrationWizard.config.wizardConfig.searchInterface",
      description: "ui.integrationWizard.config.wizardConfig.adjustTheSearchLayoutBeforeFinalThemeReview",
      validate: () => true,
      visible: () => true,
    },
    {
      id: 'theme-configuration',
      title: "ui.integrationWizard.config.wizardConfig.themeColors",
      description: "ui.integrationWizard.config.wizardConfig.chooseTheColorsUsedByYourSearchInterface",
      validate: () => true,
      visible: () => true,
    },
    {
      id: STEP_IDS.SUMMARY,
      title: "ui.integrationWizard.config.wizardConfig.buildPreview",
      description: "ui.integrationWizard.config.wizardConfig.previewSearchOnYourStoreBeforeGoingLive",
      validate: () => true,
      visible: () => true,
    },
  ],

  getActiveSteps(wizardData = {}) {
    return this.steps.filter((step) => step.visible(wizardData));
  },

  getStepIndex(stepId, wizardData = {}) {
    const activeSteps = this.getActiveSteps(wizardData);
    return activeSteps.findIndex((step) => step.id === stepId);
  },

  getStepById(stepId) {
    return this.steps.find((step) => step.id === stepId);
  },

  isStepBlocked(stepId) {
    const step = this.getStepById(stepId);
    return step?.blocked ? step.blocked() : false;
  },

  canProceed(currentStepIndex, wizardData = {}) {
    const activeSteps = this.getActiveSteps(wizardData);
    const currentStep = activeSteps[currentStepIndex];

    if (!currentStep) {
      return false;
    }

    if (currentStep.blocked && currentStep.blocked()) {
      return false;
    }

    return currentStep.validate(wizardData);
  },
};

export default WIZARD_CONFIG;
